import assign from 'lodash/assign';
import constants from '../constants';

const initState = () => ({
  hostname: null,
  device: {
    isMobile: false,
    screenWidth: 'xl',
  },
  apiResponseServerSideRequestCookies: [],
  originalServerSideRequestCookies: {},
  googleMapsApiKey: null,
  isProd: false,
  stats: {},
  fromApp: false,
});

const app = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.UPDATE_APP) {
    return assign({}, state, payload);
  }
  return state;
};

export default app;
